import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AlarmIcon from '@material-ui/icons/Alarm';
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>APERÇU</h2>
          <h5 className={classes.description}>
          La naissance de ChiNcoDrive est venue d’une volonté de rendre le transport de personnes accessible à tous.
          
          Les services proposés aujourd’hui à travers les multinationales ou les services élitistes sont majoritairement réservés à une certaine tranche de la population.
          
          ChiNcoDrive s’engage auprès des utilisateurs sur la transparence du prix de la course dès la commande pour qu’il n’y ait pas de mauvaises surprises à l’arrivée.
          
          Les prix pratiqués par ChiNcoDrive permettront à chacun d’utiliser le service en choisissant le niveau de prestation désiré.
          
          Apporter plus de sécurité, de transparence sur les prix et de travail pour les chauffeurs.
          
          L’objectif de ChiNcoDrive est de mettre en relation les chauffeurs et les clients.
          
          La promesse de ChiNcoDrive est simple, nous n’envisageons pas un monde dicté par les multinationales du VTC
          
          Notre priorité est d’accompagner les acteurs du marché du taxi pour offrir une vraie alternative aux transports de personne haut de gamme.          
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Chauffeurs"
              description="ChiNcoDrive vous connecte avec des chauffeurs professionnels connaissant parfaitement la ville."
              icon={EmojiTransportationIcon}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Commande rapide"
              description="L'application ChiNcoDrive vous permet de commander ou programmer une course en 2 clics et de suivre l’arrivée du chauffeur où que vous soyez. "
              icon={AlarmIcon}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Prix sur mesure"
              description="ChiNcoDrive détermine avec précision le prix idéal pour chaque course. Le client est satisfait, le chauffeur aussi, tout le monde est content."
              icon={VerifiedUser}
              iconColor="success"
              vertical
            />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
